export default __webpack_public_path__ + "static/media/Component57–1.81f19de9.svg";